
/*************************************************
 Import Scripts in before-init Folder
*************************************************/
import './before-init/header';


/*************************************************
 Import init.js script
*************************************************/
import './init';


/*************************************************
 Import Scripts in after-init Folder
*************************************************/
import './after-init/app';
import './after-init/filter';
import './after-init/blocks';
